
import React from "react";
import {MDBCardImage, MDBCol, MDBView } from "mdbreact";
import Fade from 'react-reveal/Fade';
import { transform } from "@babel/core";

const WavesPage = () => {

    function newPointer(e) {
        e.target.style.cursor = 'pointer';
    }

    function addSiteLink() {
        let x = document.getElementById('siteLink');
        
            
        
        
    }

    return (
       
        <div className="row" style={{ marginTop: "25px"}}>
            
            <MDBCol className="col-lg-3" lg="4" md="6">
                
                <div style={{ position: "relative", marginBottom: "25px"}}>                     
                 
                        <img onMouseOver={newPointer}
                            src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/6-col/img%20(54).jpg"
                        className="w-100 img-thumbnail"
                        alt=""/>
                        <div id="siteLink" className='overlay'>
                    
    
                            <div id="siteLink" style={{position: "relative", top: "50%", fontStyle: "italic"}}>
                            Coming Soon!
                            </div>
                            </div>
                        </div>

            </MDBCol>
            <MDBCol className="col-lg-3" lg="4" md="6">
                <div style={{ position: "relative", marginBottom: "25px" }}>

                    <img onMouseOver={newPointer}
                        src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/6-col/img%20(54).jpg"
                        className="w-100 img-thumbnail"
                        alt="" />
                    <div className='overlay'>


                            <div id="siteLink" style={{ position: "relative", top: "50%", fontStyle: "italic" }}>
                            Coming Soon!
                            </div>
                    </div>
                </div>
            </MDBCol>
            <MDBCol className="col-lg-3" lg="4" md="6">
                <div style={{ position: "relative", marginBottom: "25px" }}>

                    <img onMouseOver={newPointer}
                        src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/6-col/img%20(54).jpg"
                        className="w-100 img-thumbnail"
                        alt="" />
                    <div className='overlay'>


                        <div id="siteLink" style={{ position: "relative", top: "50%", fontStyle: "italic" }}>
                            Coming Soon!
                            </div>
                    </div>
                </div>
            </MDBCol>
           
        </div>
        
    );
}

export default WavesPage;